import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import ImagesModalCarousel from "../ImagesModalCarousel";
import FormModalProjetClient from "../FormModalProjetClient";
import { loadUserProfile } from "../../redux/actions/authActions";
import PrestatairesDashboard from "../PrestatairesDashboard";
import LikesSentDashboard from "../LikesSendDashboard";
import LikesReceivedDashboard from "../LikesReceivedDashboard";
import PrestatairesMatchesDashboardClient from "../PrestatairesMatchesDashboardClient";
import { setActiveAppelOffre, setActiveTabAppelOffre } from "../../redux/actions/dashboardActions";
import { Document, Page, pdfjs } from "react-pdf";
import PdfModal from "../PdfModal";
import FormModalAppelOffre from "../FormModalAppelOffre";
import PrestatairesForDonneurOrdreDashboard from "../PrestatairesForDonneurOrdreDashboard";
import LikesDonneurOrdreDashboard from "../LikesDonneurOrdreDashboard";
import PrestatairesMatchesDashboardDonneurOrdre from "../PrestatairesMatchesDashboardDonneurOrdre";
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;
export default function GestionAppelsOffresV2() {
    const dispatch = useDispatch();
    const { user, token } = useSelector((state) => state.auth);
    const { activeAppelOffre, activeTabAppelOffre } = useSelector((state) => state.dashboard);
    const apiUrl = process.env.REACT_APP_API_URL;

    const [selectedProjet, setSelectedProjet] = useState(null);
    //const [activeTabProjet, setActiveTabProjet] = useState("projet");
    const [activeNameTabProjet, setActiveNameTabProjet] = useState("Projet");
    const [modalIndex, setModalIndex] = useState(null);
    const [openFormProjet, setOpenFormProjet] = useState(false);

    const [menuOpen, setMenuOpen] = useState(false); // ✅ menu burger


    const appelsOffres = user.profilDonneurOrdre.listProjetsDonneurOrdre || [];
    const images =
        activeAppelOffre?.photosProjet?.map(
            (photo) =>
                `${apiUrl}/api/files/?categorie=projets&file=${photo.fileNameFileProjet}`
        ) || [];

    const [pdfUrl, setPdfUrl] = useState(null);
    if (!user || !user.profilDonneurOrdre) return <p>Chargement...</p>;

    const openPdf = (file, categorie) => {
        setPdfUrl(`${apiUrl}/api/files/?categorie=${categorie}&file=${file}`);
    };
    const refreshProjets = () => {
        if (token) dispatch(loadUserProfile(token));
    };

    const tabStyle = (tab) => ({
        padding: "10px 18px",
        cursor: "pointer",
        borderBottom:
            activeTabAppelOffre === tab ? "3px solid #007bff" : "3px solid transparent",
        fontWeight: activeTabAppelOffre === tab ? "bold" : "normal",
        transition: ".25s",
    });

    const handleTabClick = (tab) => {
        dispatch(setActiveTabAppelOffre(tab));
        console.log(activeTabAppelOffre);
        setMenuOpen(false);
    };

    const getActiveTabName = () => {

        switch (activeTabAppelOffre) {
            case "projet":
                return "Mon appel d'offres";
            case "trouver":
                return "Trouver un prestataire";
            case "likesSent":
                return "Likes envoyés";
            case "likesReceived":
                return "Likes reçus";
            case "matchs":
                return "Matchs actifs";
        }
    }

    return (
        <div className="gestion-projet">

            <style>{`
                /* ---------------------------------------------------------
                    🌐 Responsive styles
                ---------------------------------------------------------- */
                .tabs-container {
                    display: flex;
                    gap: 20px;
                    margin-top: 15px;
                    margin-bottom: 25px;
                }

                /* -------- Menu burger visible mobile -------- */
                .burger-btn {
                    display: none;
                    background: #007bff;
                    color: white;
                    border: none;
                    padding: 10px 15px;
                    border-radius: 6px;
                    font-size: 16px;
                    cursor: pointer;
                }

                @media (max-width: 768px) {
                    .tabs-container {
                        display: none;
                    }
                    .burger-btn {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        width:fit-content;
                        margin:auto;

                    }
                    .burger-menu {
                        background: white;
                        border: 1px solid #ddd;
                        border-radius: 8px;
                        padding: 15px;
                        margin-bottom: 20px;
                        box-shadow: 0 4px 10px rgba(0,0,0,0.1);
                    }
                    .burger-item {
                        padding: 12px 10px;
                        border-bottom: 1px solid #eee;
                        cursor: pointer;
                        font-size: 16px;
                    }
                    .burger-item:last-child {
                        border-bottom: none;
                    }
                }
            `}</style>

            <h2 className="gestion-projet-title">
                {!activeAppelOffre
                    ? "Gestion de mes projets"
                    : "Gestion du projet " + activeAppelOffre.titreProjet}
            </h2>
            {
                activeAppelOffre && (
                    <button className="back-btn-projets" onClick={() => dispatch(setActiveAppelOffre(null))}>
                        ← Retour
                    </button>
                )
            }


            {!activeAppelOffre && (
                <button className="btn-primary" onClick={() => setOpenFormProjet(true)}>
                    Créer un nouveau projet
                </button>
            )}

            {/* ---------------------------------------------------------
                🎯 PROJET SELECTIONNÉ
            ---------------------------------------------------------- */}
            {activeAppelOffre ? (
                <div className="projet-detail">


                    {/* ======== 🍔 BOUTON BURGER MOBILE ======== */}
                    <button className="burger-btn" onClick={() => setMenuOpen(!menuOpen)}>
                        {getActiveTabName()}<span>{menuOpen ? "▲" : "▼"}</span>
                    </button>

                    {/* ======== 🍔 MENU BURGER OUVERT ======== */}
                    {menuOpen && (
                        <div className="burger-menu">
                            <div className="burger-item" onClick={() => handleTabClick("projet")}>Mon appel d'offres</div>
                            <div className="burger-item" onClick={() => handleTabClick("trouver")}>Trouver un prestataire</div>
                            <div className="burger-item" onClick={() => handleTabClick("likesSent")}>Likes envoyés</div>
                            <div className="burger-item" onClick={() => handleTabClick("likesReceived")}>Likes reçus</div>
                            <div className="burger-item" onClick={() => handleTabClick("matchs")}>Matchs actifs</div>
                        </div>
                    )}

                    {/* ======== TABS DESKTOP ======== */}
                    <div className="tabs-container">
                        <div style={tabStyle("projet")} onClick={() => dispatch(setActiveTabAppelOffre("projet"))}>
                            Mon appel d'offres
                        </div>
                        <div style={tabStyle("trouver")} onClick={() => dispatch(setActiveTabAppelOffre("trouver"))}>
                            Trouver un prestataire
                        </div>
                        <div style={tabStyle("likesSent")} onClick={() => dispatch(setActiveTabAppelOffre("likesSent"))}>
                            Likes envoyés
                        </div>
                        <div style={tabStyle("likesReceived")} onClick={() => dispatch(setActiveTabAppelOffre("likesReceived"))}>
                            Likes reçus
                        </div>
                        <div style={tabStyle("matchs")} onClick={() => dispatch(setActiveTabAppelOffre("matchs"))}>
                            Matchs actifs
                        </div>
                    </div>

                    {/* ---------------------------------------------------------
                        CONTENU DES TABS
                    ---------------------------------------------------------- */}
                    {activeTabAppelOffre === "projet" && (
                        <>
                            <h3>{activeAppelOffre.titreProjet}</h3>
                            <p>{activeAppelOffre.descriptionProjet}</p>

                            <div className="projet-infos">
                                <p>
                                    <strong>Secteur :</strong> {activeAppelOffre.secteurProjet}
                                </p>

                                <p>
                                    <strong>Ville :</strong> {activeAppelOffre.villeProjet}
                                </p>
                                <p>
                                    <strong>Status :</strong> {activeAppelOffre.statusProjet}
                                </p>
                            </div>

                            {activeAppelOffre.besoinsProjet?.length > 0 && (
                                <div className="projet-besoins">
                                    {activeAppelOffre.besoinsProjet.map((besoin) => (
                                        <span
                                            key={besoin.idBesoinProjet}
                                            className="besoin-badge"
                                        >
                                            <img
                                                src={`${apiUrl}/api/files/?categorie=metiers&file=${besoin.metier.iconMetier}`}
                                                alt={besoin.metier.labelMetier}
                                                className="besoin-icon"
                                            />
                                            {besoin.metier.labelMetier} (x{besoin.nbPersonnes})
                                        </span>
                                    ))}
                                </div>
                            )}

                            <div className="section">
                                <h4>Photos</h4>
                                {activeAppelOffre.photosProjet?.length > 0 ? (
                                    <div className="photo-gallery">
                                        {images.map((src, index) => (
                                            <img
                                                key={index}
                                                src={src}
                                                className="photo-thumb"
                                                onClick={() => setModalIndex(index)}
                                            />
                                        ))}
                                    </div>
                                ) : (
                                    <p>Aucune photo pour ce projet.</p>
                                )}
                            </div>

                            <div className="section">
                                <h4>📎 Documents</h4>
                                {activeAppelOffre.docsProjet?.map((doc) => (
                                    <div
                                        className="pdf-thumbnail"
                                        onClick={() => openPdf(doc.fileNameFileProjet, "projets")}
                                    >
                                        <Document
                                            file={`${apiUrl}/api/files/?categorie=projets&file=${doc.fileNameFileProjet}`}
                                        >
                                            <Page pageNumber={1} width={120} /> {/* miniature */}
                                        </Document>
                                    </div>
                                ))}
                            </div>
                        </>
                    )}

                    {activeTabAppelOffre === "trouver" && (
                        <PrestatairesForDonneurOrdreDashboard appelOffre={activeAppelOffre} />
                    )}
                    {activeTabAppelOffre === "likesSent" && (
                        <LikesDonneurOrdreDashboard type="sent" idProjet={activeAppelOffre.idProjet} />
                    )}
                    {activeTabAppelOffre === "likesReceived" && (
                        <LikesDonneurOrdreDashboard type="received" idProjet={activeAppelOffre.idProjet}/>
                    )}
                    {activeTabAppelOffre === "matchs" && (
                        <PrestatairesMatchesDashboardDonneurOrdre
                            appelOffre={activeAppelOffre}
                        />
                    )}

                    {modalIndex !== null && (
                        <ImagesModalCarousel
                            images={images}
                            startIndex={modalIndex}
                            onClose={() => setModalIndex(null)}
                        />
                    )}
                </div>
            ) : (
                <div className="projets-grid">
                    {appelsOffres.map((projet) => (
                        <div
                            key={projet.idProjet}
                            className="projet-card clickable"
                            onClick={() => {
                                dispatch(setActiveAppelOffre(projet));
                                dispatch(setActiveTabAppelOffre("projet"));
                            }}
                        >
                            <div className="projet-header">
                                <h3 className="projet-title">{projet.titreProjet}</h3>
                                <span
                                    className={`status-badge status-${projet.statusProjet}`}
                                >
                                    {projet.statusProjet}
                                </span>
                            </div>
                            <p>{projet.descriptionProjet.slice(0, 80)}...</p>
                        </div>
                    ))}
                </div>
            )}

            {openFormProjet && (
                <FormModalAppelOffre
                    onClose={() => {
                        setOpenFormProjet(false);
                        refreshProjets();
                    }}
                />
            )}
            
            {pdfUrl && <PdfModal fileUrl={pdfUrl} onClose={() => setPdfUrl(null)} />}
            
        </div>
    );
}
